export const routePath = (page: string) => {
  switch (page) {
    case 'Dashboard':
      return '/dashboard';
    case 'Analytics':
      return '/analytics';
    case 'Premium Hiring Clients':
    case 'Managed Clients':
    case 'My Accounts':
      return '/my-accounts';
    case 'Jobs':
      return '/jobs';
    case 'Companies':
      return '/companies';
    case 'Job Seekers':
      return '/jobseekers';
    case 'Employers':
      return '/employers';
    case 'HR':
      return '/hr';
    case 'Applications':
      return '/applications/list';
    case 'Guides':
      return '/guides';
    case 'Agreements':
      return '/agreements';
    case 'Drip Campaigns':
      return '/email-campaigns/drip-enrollments';
    case 'Automated Emails':
      return '/email-campaigns/automation-rules';
    case 'Email Templates':
      return '/email-campaigns/templates';
    case 'Email Tracking':
      return '/email-campaigns/send-log';
    case 'User RBAC':
      return '/user-rbac';
    case 'Settings':
      return '/job-metadata';
    case 'Subscriptions':
      return '/subscriptions';
    case 'Promo codes':
      return '/promo-codes';
    case 'Free Job Alerts':
      return '/free-job-alerts';
    case 'Cloud & AI Costs':
      return '/cloud-costs/all';
    // case 'Requests':
    //   return '/company-requests';
    case 'Login':
      return '/login';
    default:
      return '*';
  }
};
